import React from 'react'

const Temp = () => {
  return (
    <div>Crops</div>
  )
}

export default Temp